import { createSelector } from 'react-sweet-state';

import type { FieldId } from '../../../../common/types/form/form-fields';
import type { FormRendererState } from '../../types';

export interface CombinedFieldSelectorProps {
	fieldId: FieldId;
}

/*
 * Selector to get the current value of a form field
 * This combines a form field value with unsaved modified value it may have
 */
export const currentValueSelector: import('react-sweet-state').OutputSelector<
	FormRendererState,
	CombinedFieldSelectorProps,
	| import('../../../..').AdfValue
	| import('../../../..').DateTimeValue
	| import('../../../..').DateValue
	| import('../../../..').FilesValue
	| import('../../../..').LocalTimeValue
	| import('../../../..').NumberValue
	| import('../../../..').OptionsValue
	| import('../../../..').TextValue
	| undefined
> = createSelector(
	(state: FormRendererState) => state.formFields,
	(state: FormRendererState) => state.modifiedValues,
	(_, props: CombinedFieldSelectorProps) => props.fieldId,
	(formFields, modifiedValues, fieldId) =>
		fieldId in modifiedValues ? (modifiedValues[fieldId] ?? undefined) : formFields[fieldId]?.value,
);
